module.exports = __webpack_public_path__ + "images/puzzle/Puzzle/PNG/Piece01.8b56f01dad2933c43a40955cfdc39ac6.png";